export default __webpack_public_path__ + "static/media/auth_background_mobile.8b3719ab.png";